var $link = null;
var _isEmpty = function (input) {
  return input + '' === 'null' || input + '' === 'undefined' || input === '';
};
var _toString = function (data) {
  return !!data ? data + '' : '';
};
var _isGroupUser = function (contact) {
  return contact && contact.user_source && Number(contact.user_source) > 10000;
};
var _isShopModeUserSource = function (source) {
  return !_isEmpty(source) && Number(source) == 9999;
}
var _isShopModeUser = function (obj, me) {
  var isShopModeUser = false;
  if (_isEmpty(obj)) {
    isShopModeUser = false;
  } else if (!_isEmpty(obj.is_shop_mode) && obj.is_shop_mode) {
    // user判断
    isShopModeUser = true;
  } else if (!_isEmpty(obj.sender_source) && !_isEmpty(obj.to_source)) {
    // msg判断
    var isShopModeUserSource = _isShopModeUserSource(obj.sender_source) || _isShopModeUserSource(obj.to_source);
    var sendKey = obj.sender_id + '@' + obj.sender_source;
    var toKey = obj.to_id + '@' + obj.to_source;
    var meKey = me ? me.user_id + '@' + me.user_source : null;
    isShopModeUser = isShopModeUserSource && meKey && sendKey != meKey && toKey != meKey;
  } else if (!_isEmpty(obj.user_source)) {
    // contact判断
    isShopModeUser = _isShopModeUserSource(obj.user_source);
  }
  return isShopModeUser;
}
var _getShopKey = function (msg, me) {
  if (_isEmpty(msg) || !_isShopModeUser(msg, me)) {
    return null;
  }
  var sendKey = msg.sender_id + '@' + msg.sender_source;
  var toKey = msg.to_id + '@' + msg.to_source;
  return _isShopModeUserSource(msg.sender_source) ? sendKey : _isShopModeUserSource(msg.to_source) ? toKey : null;
}
var _jsonHandler = {};
_jsonHandler.parse = function (data) {
  try {
    data = JSON.parse(data);
  } catch (e) {
    data = e;
  }
  return data;
};
_jsonHandler.stringify = function (data) {
  try {
    data = JSON.stringify(data);
  } catch (e) {
    data = '';
  }
  return data;
};

var supportCss3 = function (style) {
  var prefix = ['webkit', 'Moz', 'ms', 'o'],
    i,
    humpString = [],
    htmlStyle = document.documentElement.style,
    _toHumb = function (string) {
      return string.replace(/-(\w)/g, function ($0, $1) {
        return $1.toUpperCase();
      });
    };

  for (i in prefix)
    humpString.push(_toHumb(prefix[i] + '-' + style));

  humpString.push(_toHumb(style));

  for (i in humpString)
    if (humpString[i] in htmlStyle) return true;

  return false;
};

var wrapText = function (detail, maxWidth, font) {
  let result = '';
  let canvas = document.createElement('canvas');
  let ctx = canvas.getContext('2d');
  font = font || '14px Arial';
  ctx.font = font;
  //如果小于两行直接返回
  if (ctx.measureText(detail).width < (maxWidth)) {
    return detail;
  }
  //如果大于两行则截断处理
  for (let i = 1; i < detail.length; i++) {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    ctx.font = font;
    let label = detail.slice(0, i);
    let width = ctx.measureText(label).width;
    if (+(width + 16) > (maxWidth)) {
      result = label + '...';
      break;
    }
  }
  return result;
}

var getlines = function (maxWidth, msg, font) {
  let canvas = document.createElement('canvas');
  let ctx = canvas.getContext('2d');
  font = font || '12px Arial';
  ctx.font = font;
  //如果小于两行直接返回
  return ctx.measureText(msg).width / maxWidth;
}
var _isMeSender = function (msg, me) {
  var currentuser = me;
  var isMeSender;
  var sendKey = msg.sender_id + '@' + msg.sender_source;
  var toKey = msg.to_id + '@' + msg.to_source;
  var meKey = currentuser.user_id + '@' + currentuser.user_source;
  var kfKey = msg.kf_id + '@' + msg.kf_source;
  isMeSender = meKey === sendKey || (meKey == kfKey && meKey !== toKey && meKey !== sendKey && _isShopModeUserSource(msg.sender_source));
  return isMeSender;
}

let queque = function (size) {
  var _size = 0;
  if (!isNaN(size)) {
    _size = Number(size);
  }
  var _queque = [];
  return {
    store: function (objs) {
      if (objs instanceof Array) {
        _queque = objs;
      }
    },
    add: function (obj) {
      if (_size) {
        if (_queque.length + 1 > _size) {
          _queque.shift();
        }
        _queque.push(obj);
      }
    },
    cut: function (callback) {
      if (_queque.length > _size) {
        var deleted = _queque.slice(0, _queque.length - _size);
        _queque = _queque.slice((_queque.length - _size || 0), _queque.length);
        callback && callback(deleted, _queque);
      }
    },
    push: function (objs, callback) {
      if (objs instanceof Array) {
        _queque = _queque.concat(objs);
        this.cut(callback);
      }
    },
    pull: function () {
      return _queque;
    }
  }
}
let sumBigNumber = function (a, b) {
  var res = '',
    temp = 0;
  a = a.split('');
  b = b.split('');
  while (a.length || b.length || temp) {
    temp += ~~a.pop() + ~~b.pop();
    res = (temp % 10) + res;
    temp = temp > 9;
  }
  return res.replace(/^0+/, '');
}

/* string转换为number,进行比较 */
let strToNumCompare = function (str1, str2) {
  let result = 0;
  let nagative;
  if (!str1 && !str2) {
    return result;
  }
  if (isNaN(str1) || isNaN(str2)) {
    return null;
  }

  str1 = str1 + '';
  str2 = str2 + '';
  // 负数
  if (str1.charAt(0) === '-' && str2.charAt(0) !== '-') {
    result = -1;
    return result;
  } else if (str1.charAt(0) !== '-' && str2.charAt(0) === '-') {
    result = 1;
    return result;
  }
  if (str1.charAt(0) === '-' && str2.charAt(0) === '-') {
    str1 = str1.substring(1);
    str2 = str2.substring(1);
    nagative = true;
  }
  let len1 = str1.length;
  let len2 = str2.length;
  if (len1 > len2) {
    result = 1;
  } else if (len1 < len2) {
    result = -1;
  } else if (len1 === len2) {
    for (let i = 0; i < len1; i++) {
      if (str1[i] > str2[i]) {
        result = 1;
        break;
      } else if (str1[i] < str2[i]) {
        result = -1;
        break;
      } else if (str1[i] === str2[i]) {
        continue;
      }
    }
  }

  if (nagative) {
    result = result === 1 ? -1 : result === -1 ? 1 : 0;
  }
  return result;
};
//判断是否为匿名用户
var _isAnonymousSession = function (user) {
  return user && user.register == 0 && !_isGroupUser(user)
}
export default {
  supportCss3,
  openPage: function (url, target) {

    target = target || '_blank';
    if (!$link) {
      $link = $('<a>').css({
        display: 'hidden'
      }).appendTo($('body'));
    }

    $link.attr({
      href: url
    })[0].click();
  },
  convertImgParams: function (params) {
    var w = params.width;
    var h = params.height;
    params.unit = params.unit ? params.unit : 'px';
    var ratio = params.width / params.height;
    if (params.baseWidth) {
      w = params.baseWidth;
      h = (w / ratio);
    }
    if (params.baseHeight) {
      h = params.baseHeight;
      w = h * ratio;
    }

    return {
      width: w + params.unit,
      height: h + params.unit
    };
  },
  insertHtmlAtCaret: function (html) {
    var sel, range;
    if (window.getSelection) {
      // IE9 and non-IE
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();
        // Range.createContextualFragment() would be useful here but is
        // non-standard and not supported in all browsers (IE9, for one)
        var el = document.createElement("div");
        //粘贴文本空行的处理
        html = html.replace(/\n/g, "<br>")
        el.innerHTML = html;
        var frag = document.createDocumentFragment(),
          node, lastNode;
        while ((node = el.firstChild)) {
          lastNode = frag.appendChild(node);
        }
        range.insertNode(frag);
        // Preserve the selection
        if (lastNode) {
          range = range.cloneRange();
          range.setStartAfter(lastNode);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    } else if (document.selection && document.selection.type !== "Control") {
      // IE < 9
      document.selection.createRange().pasteHTML(html);
    }
  },
  getCursortPosition: function (element) {
    var caretOffset = 0;
    var sel;
    if (typeof window.getSelection != "undefined") { //谷歌、火狐
      sel = window.getSelection();
      if (sel.rangeCount > 0) { //选中的区域
        var range = window.getSelection().getRangeAt(0);
        var preCaretRange = range.cloneRange(); //克隆一个选中区域
        preCaretRange.selectNodeContents(element); //设置选中区域的节点内容为当前节点
        preCaretRange.setEnd(range.endContainer, range.endOffset); //重置选中区域的结束位置
        caretOffset = preCaretRange.toString().length;
      }
    } else if ((sel = document.selection) && sel.type != "Control") { //IE
      var textRange = sel.createRange();
      var preCaretTextRange = document.body.createTextRange();
      preCaretTextRange.moveToElementText(element);
      preCaretTextRange.setEndPoint("EndToEnd", textRange);
      caretOffset = preCaretTextRange.text.length;
    }
    return caretOffset;
  },
  setEndOfContenteditable: function (contentEditableElement) {
    var range, selection;
    if (document.createRange) //Firefox, Chrome, Opera, Safari, IE 9+
    {
      range = document.createRange(); //Create a range (a range is a like the selection but invisible)
      range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
      range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
      selection = window.getSelection(); //get the selection object (allows you to change selection)
      selection.removeAllRanges(); //remove any selections already made
      selection.addRange(range); //make the range you have just created the visible selection
    } else if (document.selection) //IE 8 and lower
    {
      range = document.body.createTextRange(); //Create a range (a range is a like the selection but invisible)
      range.moveToElementText(contentEditableElement); //Select the entire contents of the element with the range
      range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
      range.select(); //Select the range (make it the visible selection
    }
  },
  getClipboardData: function (e) {
    var clipboardData;
    clipboardData = e.originalEvent.clipboardData || e.clipboardData || window.clipboardData;
    if (!clipboardData) {
      return null;
    }
    var fs;
    var text;
    if (clipboardData.items && clipboardData.items.length) {
      for (var i = 0; i < clipboardData.items.length; i++) {
        var item = clipboardData.items[i];
        if (item.kind == 'file' && item.type.match(/^image\//i)) {
          fs = item.getAsFile();
        } else if (item.kind == 'string' && item.type == 'text/plain') {
          text = clipboardData.getData('text/plain')
        }
      }
    } else if (clipboardData.types && clipboardData.types.length) {
      for (var j = 0; j < clipboardData.types.length; j++) {
        if (clipboardData.types[j] == 'text/plain') {
          text = clipboardData.getData('text/plain')
        }
      }
    } else if (clipboardData && clipboardData.getData) {
      text = window.clipboardData.getData('Text');
    } else if (clipboardData.files && clipboardData.files.length) {
      fs = clipboardData.files[0];
    }
    return text ? { type: 'text', content: text } : fs ? { type: 'file', content: fs } : null;
  },
  getImgParams: function (options) {
    var minsize = options.minsize,
      maxsize = options.maxsize,
      width,
      height,
      imagParamsObj;
    if (!options.image_width || !options.image_height) {
      imagParamsObj = {
        url: options.url,
        background_size: 'cover',
        width: 250,
        height: 150,
        repeat: 'no-repeat'
      };
      return imagParamsObj;
    }

    if (options.image_width > options.image_height) {
      var ratio = options.image_width / options.image_height;
      if (ratio > maxsize / minsize) {
        height = minsize;
        width = maxsize;
      } else {
        if (options.image_width > maxsize) {
          width = maxsize;
          height = width / ratio;
        } else {
          width = options.image_width;
          height = options.image_height;
        }
      }
    } else {
      var ratio = options.image_height / options.image_width;
      if (ratio > maxsize / minsize) {
        width = minsize;
        height = maxsize;
      } else {
        if (options.image_height > maxsize) {
          height = maxsize;
          width = height / ratio;
        } else {
          width = options.image_width;
          height = options.image_height;
        }
      }
    }

    var src;
    if (options.url && options.url.indexOf('data:') === -1) {
      src = options.url + '?crop=1' + '&cpos=northwest' + '&h=' + height + '&w=' + width;
    } else {
      src = options.url;
    }

    var background_size = '';
    if (height == minsize && width == maxsize) {
      background_size = 'auto 100%';
    } else if (height == maxsize && width == minsize) {
      background_size = '100% auto';
    } else {
      background_size = '100% 100%';
    }

    return {
      url: src,
      background_size: background_size,
      width: width,
      height: height
    }
  },
  isNeedShow: function (msg, me, appid) {
    var show;
    // show_in_app逻辑
    if (!msg.options || !msg.options.show_in_app || msg.options.show_in_app.length == 0) {
      show = true;
    }
    else {
      show = false;
      var appidkey = appid.split('-')[0];
      for (var index = 0, length = msg.options.show_in_app.length; index < length; index++) {
        if (msg.options.show_in_app[index] == appidkey) {
          show = true;
          break;
        }
      }
    }
    // 对于自己发送的消息，并且options.sender_hide:1的情况下，过滤该条消息
    if (_isMeSender(msg, me)) {
      if (msg.options && msg.options.sender_hide && _toString(msg.options.sender_hide) === '1') {
        show = false;
      }
    }
    // 消息被刪除过滤(msg_status==2)
    if (!_isEmpty(msg.msg_status) && msg.msg_status + '' === '2') {
      show = false;
    }

    // 过滤掉不需要展示的替换消息体（直接删掉，会影响遍历结果，所以先将需要过滤的索引放到数组中）
    if (msg.options && msg.options.sdk_hide && msg.options.sdk_hide + '' == '1') {
      show = false;
    }
    return show;
  },
  isEmpty: _isEmpty,
  jsonHandler: _jsonHandler,
  isGroupUser: _isGroupUser,
  isShopModeUser: _isShopModeUser,
  isShopModeUserSource: _isShopModeUserSource,
  getShopKey: _getShopKey,
  is_file_helper: function (userId, userSource) {
    return userId === 'wjzs10000' && userSource === 108;
  },
  wrapText,
  getlines,
  queque,
  sumBigNumber,
  strToNumCompare,
  isAnonymousSession: _isAnonymousSession
};
